<app-navbar></app-navbar>
<section class="py-4 py-xl-5 main-section-body-content">
    <div class="container">
        <!-- create new subype -->
        <div class="row">
            <div class="col-12">
                <h4 class="mid-title">Create Type :</h4>
                <div class="d-flex align-items-center gap-2">
                    <mat-form-field class="w-100">
                        <mat-label>Type</mat-label>
                        <input matInput placeholder="Type" [(ngModel)]="type">
                    </mat-form-field>
                    <mat-button-toggle-group class="toggle-no-shrink" name="evaluation" aria-label="Evaluation Toggle" [(ngModel)]="evaluation" >
                        <mat-button-toggle value="evaluate">Evaluate</mat-button-toggle>
                        <mat-button-toggle value="no-evaluate">No Evaluation</mat-button-toggle>
                      </mat-button-toggle-group>
                    <button class="text-center min-w-auto" mat-flat-button color="primary" (click)="createType()">Create Type</button>
                </div>
            </div>
        </div>
        <!-- list all subtypes -->
        <div class="row">
            <!-- <div class="col-md-1"></div> -->
            <div class="col-lg-6">
                <!-- Table -->
                <h4 class="mid-title">Type List</h4>
                <div class="mat-elevation-z8 table-responisve subtype-creation-table w-100">
                    <table mat-table [dataSource]="typeArray" matSort>
            
                        <!-- Community Name Column -->
                        <!-- <ng-container matColumnDef="typeId">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Type Id </th>
                            <td mat-cell *matCellDef="let row"> {{row.typeId}} </td>
                        </ng-container> -->
            
                        <!-- Participants number Column -->
                        <ng-container matColumnDef="type">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Type </th>
                            <td mat-cell *matCellDef="let row"> {{row.type}} </td>
                        </ng-container>
                        <ng-container matColumnDef="evaluate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Evaluate</th>
                            <td mat-cell *matCellDef="let row">
                              {{ (row.metaData?.evaluation ?? true) ? 'True' : 'False' }}
                            </td>
                          </ng-container>
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Action </th>
                            <td mat-cell *matCellDef="let row"><button class="btn btn-success btn-sm view-subtype-btn">View SubType </button> </td>
                        </ng-container>
                        <!-- Delete type -->
                        <ng-container matColumnDef="delete">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Delete </th>
                            <td mat-cell *matCellDef="let row">
                                <button mat-mini-fab color="warn" (click)="deleteType(row.typeId)" aria-label="Example icon button with a delete icon" class="delete-btn">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </td>
                        </ng-container>
                    
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                            (click)="viewSubType(row.typeId,row.type, (row.metaData?.evaluation ?? true) ? 'True' : 'False' )"></tr>
            
                        <!-- Row shown when there is no matching data. -->
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="4">No data matching the filter</td>
                        </tr>
                    </table>
            
                    <!-- <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page of questionsArray"></mat-paginator> -->
                </div>
            </div>
            <div class="col-lg-6 mt-4 mt-lg-0">
                <div class="row" *ngIf="selectedTypeId">
                    <div class="col-md-12">
                        <h4 class="mid-title">SubType for : {{selectedTypeId}} </h4>
                    </div>
                    <div class="col-md-12">
                        <h4 class="mid-title">Evalution for Type : {{selectedEvalType}}</h4>
                    </div>
                    <mat-card class="w-100 subType-visual-spatial-box">
                        <mat-card-header></mat-card-header>
                        <mat-card-content>
                            <div *ngFor="let subtype of subTypeList" class="w-100">
                                <!-- <div class="py-2 d-flex align-items-center subtype-head-wrap">
                                    <h5 class="mb-0">{{subtype.subType}}</h5>
                                    <button mat-mini-fab color="warn" (click)="deleteSubType(subtype.typeId,subtype.subTypeId)" aria-label="Example icon button with a delete icon" class="delete-btn ml-auto">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </div> -->
                                <div class="py-2 d-flex justify-content-between align-items-center subtype-head-wrap">
                                    <h5 class="mb-0 flex-grow-1">{{ subtype.subType }}</h5>
                                    <button mat-mini-fab color="warn" (click)="deleteSubType(subtype.typeId, subtype.subTypeId)">
                                      <mat-icon>delete</mat-icon>
                                    </button>
                                  </div>
                                  
                                <mat-divider></mat-divider>
                            </div>
                        </mat-card-content>
        
                        <mat-card-footer>
                            <div class="pb-2 d-flex align-items-center subtype-head-wrap w-100 gap-4 px-3">
                                <mat-form-field class="w-100">
                                    <mat-label>Add SubType</mat-label>
                                    <input matInput placeholder="Enter SubType for {{selectedTypeId}}" [(ngModel)]="subTypeValue">    
                                </mat-form-field>
                                <button class="text-center" mat-mini-fab color="primary" (click)="createSubType()">+</button>
                            </div>
                            <!-- <button>Add SubType</button> -->
                        </mat-card-footer>
                    </mat-card>
                </div>
            </div>
            <!-- <div class="col-md-2"></div> -->
        </div>
        <!-- subtype list -->
    </div>
</section>
<app-footer></app-footer>
